import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';
import AppRouteGuard from './components/AppRouteGuard';
import Routes from './Routes';

function App() {
  return (
    <AuthProvider>
      <StripeProvider>
        <AppRouteGuard>
          <Routes />
        </AppRouteGuard>
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;